import {Component, OnInit} from '@angular/core';
import {NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {ShipmentEvent} from "../services/shipment-event";
import {ShipmentService} from "../services/shipment-service";
import {ShipmentsService} from "../services/shipments.service";

@Component({
    selector: 'app-event-forward-modal',
    templateUrl: './event-forward-modal.component.html',
    styleUrls: ['./event-forward-modal.component.scss'],
    providers: [ShipmentsService]
})
export class EventForwardModalComponent implements OnInit {
    modal: NgbModalRef;
    data = {email: null, phone: null, message: null};

    public event: ShipmentEvent;
    submitted: boolean;

    constructor(public shipmentsService: ShipmentsService) {
    }

    ngOnInit(): void {
    }

    onSubmit() {

        this.submitted = true;

        this.shipmentsService.forwardShipmentEventStates(this.event.id, this.data).then(result => {
            this.submitted = false;
            alert('sent');

        })
    }
}
